module.exports = __webpack_public_path__ + "img/vignettes-asso_0006_institut-montaigne.27a5bbb9.jpg";